import { CountryType } from "../../../PatientCare/Patientregistration/v1/type/RegistrationDataType";

export type SearchParamsType = {
  filter: {
    status: number;
    searchText: string;
    countryId: number;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  status: number;
  stateName: string;
  clinicId: number;
  createdById: number;
  countryName: string;
  countryId: number;
  stateCode: string;
  stateId: number;
};

export type MasterDataType = {
  stateId: number;
  clinicId: number;
  createdById: number;
  stateCode: string;
  stateName: string;
  stateStatus: number;
  countryId: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  stateCode: string;
  country: CountryType | null;
  stateName: string;
  stateStatus: number;
};

export const initialFormData: MasterFormDataType = {
  stateCode: "",
  country: null,
  stateName: "",
  stateStatus: 1,
};
